export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-en-f0824ba9.png'